@if (isOpen) {
  <div #header class="callout m-0 py-2 bg-green-border text-uppercase d-flex align-items-center accessories-content">
    <div class="w-100 justify-content-center text-truncate">
      <strong>
        {{(isAlternativeSearch ? "context.menu.open.article.dialog.replace_alternative" : "accessories.title" )| translate}}
      </strong>
    </div>
    <i class="mdi mdi-close mdi-lg c-pointer ms-2" (click)="closeAccessory()" id="accessory-close-button"></i>
  </div>
  <div class="row accessories">
    <div class="accessories-list mt-2 p-0 w-100" [style.max-height.px]="totalHeight - (notPrintableAvailable ? 255 : 210)">
      @if (!nothingSelected && !isAlternativeSearch) {
        <app-accessory-dropdown [selectedFilter]="addArticlePresenter?.accessoryTypeFilter?.localizationKey" [accessoryCategories]="accessoryCategories" (filterEmitter)="selectArticleType($event)"/>
      }
      @if (!nothingSelected && isAlternativeSearch) {
        <div class="dialog-search pt-1 flex-shrink-0 flex-grow-0">
          <div class="btn-group">
            <input #search type="text" spellcheck="false" class="form-control search-bar" name="search"
              placeholder="{{ 'accessories.alternatives.search' | translate }}" (keydown.enter)="performSearch(search)" />
              <button class="btn btn-primary btn-circle" (click)="performSearch(search)">
                <app-svg-icon type="search" size="medium-small"/>
              </button>
              <span (click)="search.value = ''; cancelSearch()" id="searchclear" class="mdi mdi-close"></span>
            </div>
          </div>
        }
        <!-- items -->
        @if (nothingSelected) {
          <p class="text-center">{{ "accessories.nothingSelected" | translate}}</p>
        }
        @if (accessoryList.length === 0 && !nothingSelected && !isAlternativeSearch) {
          <p class="list-empty text-center">
            {{(noSearchResults ? "accessories.emptyList" : "accessories.searching") | translate }}
          </p>
        }
        @if (accessoryList.length === 0 && !nothingSelected && isAlternativeSearch) {
          <p class="list-empty text-center">
            {{(noSearchResults ? "accessories.alternatives.emptyList" : "accessories.searching") | translate }}
          </p>
        }
        <ng-scrollbar class="mb-0_75 pb-0 border-top pt-2" [visibility]="'hover'">
          <div class="search-article-list">
            @for (accessoryItem of accessoryList; track accessoryItem) {
              <div class="accessory-list-item" data-testid="accessory-list-item">
                @if (separatedDisplayName(accessoryItem); as displayNameParts) {
                  <div class="d-flex gap-2">
                    <img (error)="handleMissingImage($event)" class="maxw-100" [src]="accessoryItem.image" />
                    <div class="d-flex flex-column gap-2">
                      <strong>{{ accessoryItem.article?.articleNo }}</strong>
                      @if (accessoryItem.customArticleNo) {
                        <p class="small i mb-0">
                          {{ accessoryItem.customArticleNo }}
                        </p>
                      }
                      <strong class="small">{{displayNameParts[0] ?? ''}}</strong>
                    </div>
                  </div>
                  <p class="mt-1 mb-1 small">{{(displayNameParts[1] ?? '') | truncate : 120}}<br>{{ accessoryItem.color }}</p>
                  <p class="small mb-0 b">{{accessoryItem.outdatedArticleLabel}}</p>
                }
                <div class="col-12 actions d-flex align-items-center">
                  <a tooltip [tooltipText]="'sidebar.search.add_to_collection' | translate" tooltipPosition="bottom"
                    (click)="addArticleToArticleCollection(accessoryItem.article)">
                    <app-svg-icon [type]="isArticleInCollection(accessoryItem.article.articleId) ? 'star-full' : 'star'" size="medium-small"/>
                  </a>
                  <a (click)="showArticleTechnicalInfo(accessoryItem.article)" tooltip
                    [tooltipText]="'sidebar.search.technical_info' | translate" tooltipPosition="bottom">
                    <app-svg-icon type="external-link" size="medium-small"/>
                  </a>
                  <button class="btn btn-sm btn-primary add ms-auto"
                    tooltip [tooltipText]="'leftPanel.button.project' | translate"
                    tooltipPosition="bottom"
                    (click)="connect(accessoryItem)">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
              </div>
            }
          </div>
        </ng-scrollbar>
      </div>
    </div>
    @if (!nothingSelected && notPrintableAvailable) {
      <div class="accessory-options w-100">
        <hr class="ms-3 me-3 mt-0">
        <div class="category-item ps-2 ms-2">
          <div class="form-check category-checkbox me-auto w-100">
            <input class="form-check-input" type="checkbox" id="checkbox2"
              [(ngModel)]="addArticlePresenter.showExcludedFromPrinter" (change)="revalidateFilters()" />
              <label class="form-check-label" for="checkbox2">{{
              "viewArticlesPopup.label.view_not_printable" | translate}}</label>
            </div>
          </div>
        </div>
      }
    }
